import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';

const SupplierInvoicesSavedFiltersViewPage = ({ childRoutes }): React.ReactElement => {
	return (
		<div>
			<Route
				path="/supplier/invoices/savedViews"
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: '/supplier/invoices/savedViews/overview',
						}}
					/>
				)}
			/>
			{childRoutes.map((r, i) => (
				<RouteWithSubRoutes key={i} {...r} />
			))}
		</div>
	);
};

export default SupplierInvoicesSavedFiltersViewPage;
